import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { makeStyles } from "@mui/styles";
import AppBar from "@mui/material/AppBar";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Button from "@mui/material/Button";
import Drawer from "@mui/material/Drawer";
import Menu from "@mui/icons-material/Menu";
import CloseRounded from "@mui/icons-material/CloseRounded";
import styles from '../../styles/headerStyle.js';
import { useTranslation } from "react-i18next";
import { Box } from '@mui/material';
import { Helmet } from "react-helmet-async";
import { useSelector } from "react-redux";
const useStyles = makeStyles(styles);

export default function Header(props) {
  const { i18n } = useTranslation();
  const isRTL = i18n.dir();
  const classes = useStyles();
  const [mobileOpen, setMobileOpen] = React.useState(false);
  const [scrolled, setScrolled] = React.useState(false);
  const { t } = useTranslation();
  const settings = useSelector(state => state.settingsdata.settings);
  React.useEffect(() => {
    if (!props.changeColorOnScroll) return undefined;

    const headerColorChange = () => {
      setScrolled(window.pageYOffset > props.changeColorOnScroll.height);
    };

    headerColorChange();
    window.addEventListener("scroll", headerColorChange, { passive: true });
    return () => window.removeEventListener("scroll", headerColorChange);
  }, [props.changeColorOnScroll]);
  const handleDrawerToggle = () => {
    setMobileOpen(!mobileOpen);
  };
  const { color, rightLinks, leftLinks, fixed, absolute } = props;
  const appBarClasses = classNames({
    [classes.appBar]: true,
    [classes[color]]: color,
    [classes.absolute]: absolute,
    [classes.fixed]: fixed,
    [classes.scrolled]: scrolled
  });
  const brandComponent = <Button
    aria-label={t('home')}
    href="/"
    className={classes.title}>
    <span className={classes.brandMark}>
      <img src={require("../../assets/img/logo138x75white.png")} alt="Laiwani" />
    </span>
  </Button>;
  const mobileLeftLinks = React.isValidElement(leftLinks)
    ? React.cloneElement(leftLinks, { onNavigate: handleDrawerToggle, mobile: true })
    : leftLinks;
  const mobileRightLinks = React.isValidElement(rightLinks)
    ? React.cloneElement(rightLinks, { onNavigate: handleDrawerToggle, mobile: true })
    : rightLinks;
  return (
    <AppBar className={appBarClasses}>
          {settings && settings.appName?
      <Helmet>
        <title>{settings.appName + " | " + t("book_your_title")}</title>
        <meta name="description" content={t("about_us_content2")}/>
      </Helmet>
      :null}
      <Toolbar className={classes.container} style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
        {leftLinks !== undefined ? brandComponent : null}
        <div className={isRTL === 'rtl' ? null : classes.flex}>
          {leftLinks !== undefined ? (
            <Box component="div" sx={{ display: { sm: 'none', md: 'block' } }} >
              {leftLinks}
            </Box>
          ) : (
            brandComponent
          )}
        </div>

        <div style={{ direction: isRTL === 'rtl' ? 'rtl' : 'ltr' }}>
          <Box component="div" sx={{ display: { sm: 'none', md: 'block', xs: 'none' } }} >
              {rightLinks}
          </Box>
        </div>
        <Box component="div" sx={{ display: { md: 'none', xs: 'block' } }} >
          <IconButton
            className={classes.menuButton}
            aria-label="open drawer"
            aria-expanded={mobileOpen}
            onClick={handleDrawerToggle}
          >
            <Menu />
          </IconButton>
        </Box>
      </Toolbar>
      <Box component="div" sx={{ display: { md: 'none', xs: 'block' } }} >
        <Drawer
          variant="temporary"
          anchor={isRTL === 'rtl' ? 'left' : 'right'}
          open={mobileOpen}
          classes={{
            paper: classes.drawerPaper
          }}
          onClose={handleDrawerToggle}
        >
          <div className={classes.drawerHeader}>
            <span className={classes.drawerBrand}>
              <img src={require("../../assets/img/logo138x75white.png")} alt="Laiwani" />
            </span>
            <IconButton
              aria-label="close drawer"
              className={classes.closeButton}
              onClick={handleDrawerToggle}
            >
              <CloseRounded />
            </IconButton>
          </div>
          <div className={classes.appResponsive}>
            {mobileLeftLinks}
            {mobileRightLinks}
          </div>
        </Drawer>
      </Box>
    </AppBar>
  );
}

Header.defaultProp = {
  color: "white"
};

Header.propTypes = {
  color: PropTypes.oneOf([
    "primary",
    "info",
    "success",
    "warning",
    "danger",
    "transparent",
    "white",
    "rose",
    "dark"
  ]),
  rightLinks: PropTypes.node,
  leftLinks: PropTypes.node,
  brand: PropTypes.string,
  fixed: PropTypes.bool,
  absolute: PropTypes.bool,
  changeColorOnScroll: PropTypes.shape({
    height: PropTypes.number.isRequired,
    color: PropTypes.oneOf([
      "primary",
      "info",
      "success",
      "warning",
      "danger",
      "transparent",
      "white",
      "rose",
      "dark",
      "header"
    ]).isRequired
  })
};
